import { useNavigate } from 'react-router-dom';

// material-ui
//import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Snackbar,
  Stack,
  TextField,
  Typography,
  //useMediaQuery,
} from '@mui/material';
import { useState } from 'react';
//import { useDispatch, useSelector } from 'react-redux';
//import { useEffect, useState } from 'react';
import { useRegisterMutation } from '../slices/usersApiSlice';
import CloseIcon from '@mui/icons-material/Close';
//import { setCredentials } from '../slices/authSlice';
//import { ToastContainer, toast } from 'react-toastify';

// ================================|| AUTH3 - LOGIN ||================================ //

const UserRegisterScreen = () => {
  //const theme = useTheme();
  //const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
  const [message, setMessage] = useState('');
  const [nameInput, setNameInput] = useState('');
  const [loginInput, setLoginInput] = useState('');
  const [passwordInput, setPasswordInput] = useState('');
  const navigate = useNavigate();
  //const dispatch = useDispatch();
  const [register] = useRegisterMutation();
  //const { userInfo } = useSelector((state) => state.auth);

  //смотрим в адресной строке не пришел ли посетитель сюда
  //при попытке попасть на другую страницу, где требуется быть авторизованным
  //const { search } = useLocation(); //вытащили этот фрагмент "?redirect=/shipping"
  // hash: ""
  // key: "gyb0pjcd"
  // pathname: "/login"
  // search: "?redirect=/shipping"
  // state: null
  //const sp = new URLSearchParams(search);
  //const redirect = sp.get('redirect') || '/'; //получили путь, куда направлялся посетитель прежде чем попал на Авторизацию или на главную

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      //If you need to access the error or success payload immediately after a mutation, you can chain .unwrap()
      await register({
        name: nameInput,
        login: loginInput,
        password: passwordInput,
        doNotToken: true,
      }).unwrap();

      //to usersApiSlice = apiSlice.injectEndpoints({login:
      //dispatch(setCredentials({ ...res }));
      navigate('/users');
    } catch (error) {
      console.log(error);
      setMessage(
        error?.data?.message || error?.message || error?.error || error
      );
    }
  };

  const vertical = 'top';
  const horizontal = 'center';

  return (
    <Dialog fullScreen open={true}>
      {/* {
        <DialogTitle sx={{ m: 0, p: 2 }} id='customized-dialog-title'>
          Регистрация
        </DialogTitle>
      } */}

      <DialogContent dividers>
        <Container maxWidth='sm' sx={{ p: 0, m: 0, maxWidth: 600 }}>
          <Grid
            item
            xs={12}
            spacing={1}
            container
            sx={{ pb: 0, mb: 0 }}
            alignItems='center'
          >
            <Grid item xs={10}>
              <Typography variant='h6'>{'Новый сотрудник'}</Typography>
            </Grid>

            <Grid
              item
              xs={2}
              justifyContent='flex-end'
              alignItems='center'
              container
            >
              <IconButton
                aria-label='settings'
                onClick={() => navigate('/users')}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Box
            sx={{
              maxWidth: 550,
              px: 3,
              py: '20px',
              width: '100%',
            }}
          >
            <div>
              <Stack spacing={1} sx={{ mb: 3 }}>
                {/* <Typography variant='h4'>Новый сотрудник</Typography> */}
                {/* <Typography color='text.secondary' variant='body2'>
                Вы здесь впервые? &nbsp;
                <Link to='/register' underline='hover' variant='subtitle2'>
                  Создать аккаунт
                </Link>
              </Typography> */}
              </Stack>
              <form noValidate>
                <Stack spacing={3}>
                  <TextField
                    id='name'
                    //ref={userRef}
                    autoComplete='off'
                    onChange={(e) => setNameInput(e.target.value)}
                    value={nameInput}
                    error={false}
                    fullWidth
                    //helperText={formik.touched.email && formik.errors.email}
                    label='Имя'
                    name='name'
                    //onBlur={formik.handleBlur}
                    //onChange={formik.handleChange}
                    type='text'
                    //value={formik.values.email}
                  />
                  <TextField
                    id='login'
                    //ref={userRef}
                    autoComplete='off'
                    onChange={(e) => setLoginInput(e.target.value)}
                    value={loginInput}
                    error={false}
                    fullWidth
                    //helperText={formik.touched.email && formik.errors.email}
                    label='Логин'
                    name='login'
                    //onBlur={formik.handleBlur}
                    //onChange={formik.handleChange}
                    type='text'
                    //value={formik.values.email}
                  />
                  <TextField
                    id='password'
                    onChange={(e) => setPasswordInput(e.target.value)}
                    value={passwordInput}
                    //required
                    error={false}
                    fullWidth
                    //helperText={'не ме'}
                    //formik.touched.password && formik.errors.password
                    //}
                    label='Пароль'
                    name='password'
                    //onBlur={formik.handleBlur}
                    //onChange={formik.handleChange}
                    type='password'
                    //value={formik.values.password}
                  />
                </Stack>
                {/* <FormHelperText sx={{ mt: 1 }}>
                  Optionally you can skip.
                </FormHelperText> */}
                {/* {formik.errors.submit && ( */}
                <Typography
                  //ref={errRef}
                  color='error'
                  sx={{ mt: 3 }}
                  variant='body2'
                >
                  {/*errMsg*/}
                </Typography>

                <Button
                  onClick={submitHandler}
                  fullWidth
                  size='large'
                  sx={{ mt: 3 }}
                  type='submit'
                  variant='contained'
                >
                  Создать профиль
                </Button>
                {/* <Button
                  fullWidth
                  size='large'
                  sx={{ mt: 3 }}
                  //onClick={handleSkip}
                >
                  Skip authentication
                </Button> */}
                {/* <Alert color='primary' severity='info' sx={{ mt: 3 }}>
                  <div>
                    Для ознакомления используйте <b>da@da.da</b> and пароль{' '}
                    <b>da!123</b>
                  </div>
                </Alert> */}
              </form>
            </div>
          </Box>
        </Container>
      </DialogContent>

      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={message !== ''}
        onClose={() => setMessage('')}
        message={message}
        key={'vertical + horizontal'}
      />
    </Dialog>
  );
};

export default UserRegisterScreen;
